import { useEffect } from "react";

const TemplateBody = ({ bodyText, setBodyText, variableSamples, setVariableSamples }) => {
  // Extract variables from body text when it changes
  useEffect(() => {
    const variables = [];
    const regex = /\{\{(\d+)\}\}/g;
    let match;
    while ((match = regex.exec(bodyText)) !== null) {
      variables.push(parseInt(match[1]));
    }

    const uniqueVariables = [...new Set(variables)].sort();

    // Initialize or update variable samples
    setVariableSamples((prev) => {
      const newSamples = [...prev];
      uniqueVariables.forEach((varNum) => {
        if (!newSamples[varNum - 1]) {
          newSamples[varNum - 1] = "";
        }
      });
      // Trim any extra samples if variables were removed
      return newSamples.slice(0, uniqueVariables.length);
    });
  }, [bodyText, setVariableSamples]);

  const handleVariableSampleChange = (index, value) => {
    const updatedSamples = [...variableSamples];
    updatedSamples[index] = value;
    setVariableSamples(updatedSamples);
  };

  const renderVariableInputs = () => {
    if (variableSamples.length === 0) return null;

    return (
      <div className="mt-3">
        <label className="form-label required">Variable Samples</label>
        <div className="cx-template-variables">
          {variableSamples.map((sample, index) => (
            <div key={index} className="cx-template-variable-input mb-2">
              <label className="form-label">
                Sample for <code>{"{{" + (index + 1) + "}}"}</code>
              </label>
              <input
                type="text"
                className="form-control"
                value={sample}
                onChange={(e) => handleVariableSampleChange(index, e.target.value)}
                required
                placeholder={`Enter sample for variable {{${index + 1}}}`}
              />
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="cx-template-section">
      <h5 className="cx-template-section-title">
        <i className="bi bi-chat-text me-2"></i>
        Body Content
      </h5>
      
      <div className="mb-3">
        <label className="form-label required">Message Body</label>
        <textarea
          className="form-control"
          rows="6"
          value={bodyText}
          onChange={(e) => setBodyText(e.target.value)}
          placeholder="Hello {{1}}, your order {{2}} is confirmed!"
          maxLength={1024}
          required
        ></textarea>
        <div className="form-text">
          Use {"{{1}}, {{2}}, ..."} for variables. {1024 - bodyText.length} characters remaining.
        </div>
      </div>

      {renderVariableInputs()}
    </div>
  );
};

export default TemplateBody;